exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.flex-between[data-v-251d5ca8] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.title[data-v-251d5ca8] {\n  font-size: 16px;\n  font-weight: 600;\n}\n.mb14[data-v-251d5ca8] {\n  margin-bottom: 14px;\n}\n", ""]);

// exports
